import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuthStore } from '@/store/authStore';
import LoginPage from '@/pages/LoginPage';
import MainLayout from '@/layouts/MainLayout';

const ExplorerPage = lazy(() => import('@/pages/ExplorerPage'));
const PeoplePage = lazy(() => import('@/pages/PeoplePage'));
const IssuesPage = lazy(() => import('@/pages/IssuesPage'));
const CalendarPage = lazy(() => import('@/pages/CalendarPage'));
const ProfilePage = lazy(() => import('@/pages/ProfilePage'));
const ForgotPasswordPage = lazy(() => import('@/pages/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('@/pages/ResetPasswordPage'));
const DeletedDataPage = lazy(() => import('@/pages/DeletedDataPage'));
const SettingsPage = lazy(() => import('@/pages/SettingsPage'));
const QRAuthPage = lazy(() => import('@/pages/QRAuthPage'));
const QRScanPage = lazy(() => import('@/pages/QRScanPage'));
const ActivityFeedPage = lazy(() => import('@/pages/ActivityFeedPage'));
const DashboardPage = lazy(() => import('@/pages/DashboardPage'));
const ImpersonatePage = lazy(() => import('@/pages/ImpersonatePage'));

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const isAuth = useAuthStore((s) => s.isAuthenticated);
  return isAuth ? <>{children}</> : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Spin size="large" /></div>}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/qr-auth" element={<QRAuthPage />} />
        <Route path="/qr-scan" element={<QRScanPage />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="explorer" element={<ExplorerPage />} />
          <Route path="people" element={<PeoplePage />} />
          <Route path="issues" element={<IssuesPage />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="deleted-data" element={<DeletedDataPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="activity-feed" element={<ActivityFeedPage />} />
          <Route path="impersonate" element={<ImpersonatePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
